import Backbone from 'backbone';
import $ from 'jquery';
import * as pgrid from 'projection-grid';
import { uiBlockerPlugin } from '@bingads-webui/projection-grid-uiblocker';
import { getConfig } from './grid-config';
import template from './template.pug';

export class RecommendationHistoryGrid extends Backbone.View {
  initialize({
    i18n,
    newI18n,
    recommendationService,
    appConfig,
    currentActivity,
  }) {
    this.i18n = i18n;
    this.newI18n = newI18n;
    this.appConfig = appConfig;
    this.currentActivity = currentActivity;
    this.recommendationService = recommendationService;

    this.gridFactory = pgrid.factory({ vnext: true })
      .use(uiBlockerPlugin);
  }

  get events() {
    return {
      'click .recommendation-history-download': 'download',
    };
  }

  download(e) {
    const key = $(e.target).parents('tr[data-key]').data('key');
    const { AdoptionId } = this.grid.gridView.itemWithKey(key);
    this.recommendationService.downloadHistory(AdoptionId);
  }

  render() {
    this.$el.html(template());

    const config = getConfig({
      i18n: this.i18n,
      newI18n: this.newI18n,
      el: this.$('.recommendation-result-grid'),
      view: this,
      recommendationService: this.recommendationService,
      appConfig: this.appConfig,
      currentActivity: this.currentActivity,
    });

    this.grid = this.gridFactory.create(config);
    const $grid = this.grid.gridView.render().$el;
    this.$('.grid-table').append($grid);
    return this;
  }
}
